import React, { FC, ReactElement } from 'react';
import { Navigate } from 'react-router-dom';
import { getFromStorage } from '../utils/Helper';
import { StorageConstant } from '../constants/Constants';

/** Redirects away from auth pages when a session token exists (e.g. login → home). */
const PublicOnlyRoute: FC<{ children: ReactElement }> = ({ children }) => {
  if (getFromStorage({ key: StorageConstant?.ACCESS_TOKEN })) {
    return <Navigate to="/" replace />;
  }
  return children;
};

export default PublicOnlyRoute;
